export const iconFontAwesomeMovingDolly = (
	<i className="fa-solid fa-dolly"></i>
);
